import { ControlePrestaties } from '../client/procescontroleclient';
import Table from "../components/tables/Table";
import { TableType } from '../Types';

interface ProcesControlePrestatiesOverigProps {
  name: string;
  data: ControlePrestaties[];
}

export default function ProcesControlePrestatiesOverig(props: ProcesControlePrestatiesOverigProps) {

  return (
          <div key={props.name}>
            <Table tableType={TableType.Default} filterheader stickymodal>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', width: "25%" }} scope="col">{props.name}</th>
                  <th style={{ textAlign: 'center', width: "25%" }} scope="col">Regels Totaal</th>
                  <th style={{ textAlign: 'center', width: "25%" }} scope="col">Regels Verwerkt</th>
                  <th style={{ textAlign: 'center', width: "25%" }} scope="col">Score</th>
                </tr>
              </thead>
              <tbody>
                {props.data?.map((row: ControlePrestaties) => {
                  return (
                    <tr key={row.rol}>
                      <td>{row.rol}</td>
                      <td style={{ textAlign: 'center' }}>{row.regelsTotaal}</td>
                      <td style={{ textAlign: 'center' }}>{row.regelsVerwerkt}</td>
                      <td style={{ textAlign: 'center' }}>{row.score}%</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>
    );
}